// Google Analytics 4 utility functions

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const trackPageView = (path: string, title?: string) => {
  if (!window.gtag || !GA_MEASUREMENT_ID) return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title,
  });
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (!window.gtag) return;
  window.gtag('event', eventName, params);
};

export const setAnalyticsUserId = (userId: number | string) => {
  if (!window.gtag || !GA_MEASUREMENT_ID) return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    user_id: String(userId),
  });
};

export const clearAnalyticsUserId = () => {
  if (!window.gtag || !GA_MEASUREMENT_ID) return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    user_id: undefined,
  });
};
